import { Component, OnInit } from "@angular/core";
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";

@Component({
  selector: "app-life-at-iti",
  templateUrl: "./life-at-iti.component.html",
  styleUrls: ["./life-at-iti.component.scss"],
})
export class LifeAtItiComponent implements OnInit {
  banners = [];

  latestNav: any = {};

  constructor(public apiService: ApiService) {}

  ngOnInit() {
    this.setCareerPageBanner();
  }

  private setCareerPageBanner() {
    let sourceBanner;
    if (window.innerWidth <= 768) {
      sourceBanner = "M";
    } else {
      sourceBanner = "";
    }
    const obj = {
      source: sourceBanner,
      bannerType: "Banners for Careers",
    };
    this.apiService
      .postData(Urls.getBanners, obj)
      .subscribe((response: any) => {
        this.banners = response.data.banners;
        this.getLatestNav();
      });
  }

  getLatestNav = () => {
    this.apiService.getData(Urls.getLatestNav).subscribe((response: any) => {
      this.latestNav = response.data.returnList[0];
    });
  };
}
